module.exports = __webpack_public_path__ + "img/check.0348b704.svg";